<template>
    <div class="error-section-type-1">
        <div class="error-message">{{
            error.message ?
                $te(`errors.${error.message}`) ? $t(`errors.${error.message}`) : $t('errors.loading') :
            error.error_code ? $te(`errors.${error.error_code}`) ? $t(`errors.${error.error_code}`) : error.error_code :
                error
        }}</div>
    </div>
</template>

<script>
export default {
    name: "ErrorSection",
    props: {
        error: {
            type: Object,
            required: true
        }
    }
}
</script>